import { useTooltipContentProps as o } from "./index680.js";
import { useTooltipTriggerProps as e } from "./index688.js";
import { popperArrowProps as r } from "./index667.js";
import { createModelToggleComposable as p } from "./index689.js";
import { popperProps as s } from "./index665.js";
import { buildProps as l } from "./index601.js";
const {
  useModelToggleProps: t,
  useModelToggleEmits: i,
  useModelToggle: P
} = p("visible"), n = l({
  ...s,
  ...t,
  ...o,
  ...e,
  ...r,
  /**
   * @description whether the tooltip content has an arrow
   */
  showArrow: {
    type: Boolean,
    default: !0
  }
}), M = [
  ...i,
  "before-show",
  "before-hide",
  "show",
  "hide",
  "open",
  "close"
];
export {
  M as tooltipEmits,
  P as useTooltipModelToggle,
  i as useTooltipModelToggleEmits,
  t as useTooltipModelToggleProps,
  n as useTooltipProps
};
